import { createContext } from "react";

const Context = createContext();
Context.displayName = "KioskContext";

export default Context;
